import dynamic from 'next/dynamic';

import { useModal } from '~hooks/useModal';
import { useTranslations } from '~i18n/hooks';
import { ButtonSecondary } from '~shared/ui/atoms/Buttons/ButtonSecondary';
import { CounterBadge } from '~shared/ui/atoms/CounterBadge';

const GridFiltersModal = dynamic(
	() => import('../GridFiltersModal').then((mod) => mod.GridFiltersModal),
	{
		ssr: false,
	}
);

type Props = {
	count: number;
	skeleton?: boolean;
};

export const OpenFiltersModalButton = ({ count, skeleton }: Props) => {
	const t = useTranslations('GridFilters');

	const { open, close, isOpen } = useModal();

	return (
		<>
			<ButtonSecondary
				data-name="open-filters-button"
				size="M"
				skeleton={skeleton}
				disabledIconStyles={true}
				leftIcon={count > 0 && <CounterBadge count={count} />}
				onClick={open()}
			>
				{t('openFiltersButton')}
			</ButtonSecondary>

			{isOpen ? (
				<GridFiltersModal opened={true} onClose={() => close()} />
			) : null}
		</>
	);
};
